module.exports = __webpack_public_path__ + "media/images/shared/avatar-6d7055cce4b60799735166146cab36fd.svg";